import { isLoading } from "./store";
let testMode = false;
let get_user = "";
let add_user = "";
let update_user = "";
let fetch_data = "";
let api_data = "";
if (testMode) {
    get_user = "http://localhost:3000/getUser/";
    add_user = "http://localhost:3000/addUser";
    update_user = "http://localhost:3000/updateUser";
    fetch_data = "http://localhost:3000/fetchData";
    api_data = "http://localhost:3000/apiData";
}
else {
    get_user = process.env.GETUSER;
    add_user = process.env.ADDUSER;
    update_user = process.env.UPDATEUSER;
    fetch_data = process.env.FETCHDATA;
    api_data = process.env.API_DATA;
}
export const addUser = async (userData) => {
    const response = await fetch(add_user, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify(userData),
    });
    if (!response.ok) {
        console.log("Failed to add user.");
    }
    return await response.json();
};
export const getUser = async (id) => {
    try {
        const response = await fetch(get_user + id);
        if (!response.ok) {
            if (response.status === 404) {
                return 0; // User not found
            }
            // console.log("Failed to get user.");
        }
        const userData = await response.json();
        if (userData.identityVerified === undefined) {
            userData.identityVerified = false;
        }
        // add premium = false and lastlogin = new Date() to userData
        // check if the userData first contains those fields
        if (userData.premium === undefined || userData.lastlogin === undefined) {
            // append current user's entry with premium = false and lastlogin = new Date()
            userData.premium = false;
            userData.lastlogin = new Date();
            // update the user's entry in the database
        }
        userData.lastlogin = new Date();
        const newResp = await fetch(update_user, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(userData),
        });
        if (!newResp.ok) {
            console.log("Failed to update user.");
        }
        return userData;
    }
    catch (error) {
        console.error("Error getting user: ", error);
    }
};
export const fetchData = async (accessToken) => {
    isLoading.set(true);
    try {
        const response = await fetch(fetch_data, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ accessToken }),
        });
        if (!response.ok) {
            // console.log(response);
        }
        const userData = await response.json();
        isLoading.set(false);
        return userData;
    }
    catch (error) {
        console.error("Error fetching data: ", error);
        isLoading.set(false);
    }
};
export const getAPISubscription = async (userId) => {
    try {
        const response = await fetch(api_data, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ userId }),
        });
        if (!response.ok) {
            console.log("Failed to get API subscription");
        }
        const apiData = await response.json();
        return apiData;
    }
    catch (error) {
        console.error("Error getting API subscription: ", error);
    }
};
